import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-documents-vendor',
  templateUrl: './upload-documents-vendor.component.html',
  styleUrls: ['./upload-documents-vendor.component.css']
})
export class UploadDocumentsVendorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
